import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback } from 'react';

import { currentEstimateBasisGql } from '../createOrEditUerQueries';

const requestId = 'currentEstimateBasis';

export const useCurrentEstimateBasis = (setCheckboxValues: (value: Record<string, boolean>) => void) => {
    const onErrorUpdater = useCallback(() => {
        setCheckboxValues({});
    }, [setCheckboxValues]);

    const [currentEstimateBasisData, , , currentEstimateBasisRequest] = useRequest({
        requestId,
        query: currentEstimateBasisGql,
        withEffect: false,
        onErrorUpdater,
    });

    const [resetCurrentEstimateBasis] = useResetStoreData({ requestId });

    return {
        currentEstimateBasisRequest,
        resetCurrentEstimateBasis,
        currentEstimateBasisData: currentEstimateBasisData?.uerCurrentEstimateBasis,
    };
};
